import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { auth, signInWithEmailAndPassword, signInWithGoogle, firebase_update_user_info, firebase_get_uid } from "./firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import moment from "moment-timezone";

import LPGBackground from "./images/lpg_background_small.png";

import "./Login.css";
import { Typography } from "@material-ui/core";
import Stack from '@mui/material/Stack';

import GLogo from './images/G_logo.svg';
import PlayStore from './images/google_play.png';

const styles = {
  container: {
      backgroundImage: `url(${LPGBackground})`,
      backgroundPosition: 'center',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      width: '100vw',
      height: '100vh'
  }
};

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [user, loading, error] = useAuthState(auth);
  const history = useHistory();

  useEffect(async () => {
    if (loading) {
      // maybe trigger a loading screen
      return;
    }
    if (user) 
    {
     /* firebase_update_user_info(user.uid, 
      {
        "photoURL": user.photoURL,
        "displayName": user.displayName,
        "last_logged_in": moment().format()
      }); */
      //sessionStorage.setItem("uid", user.uid);
      sessionStorage.setItem("email", user.email);
      sessionStorage.setItem("photoURL", user.photoURL);
      sessionStorage.setItem("displayName", user.displayName);
      const uid = await firebase_get_uid(user.email);
      sessionStorage.setItem("uid", uid);

      history.push({
        pathname: '/dashboard',
        state: {
          uid: uid,
          email: user.email,
          photoURL: user.photoURL,
          displayName: user.displayName,
        }
      });
    }
  }, [user, loading]);

  return (
    <div className="login">
      <Stack direction="column">
      <Typography variant="h4" style={{color:"#ffffff"}} >LPG Just Gets Smarter</Typography>
      <div className="login__container">
        {/*<input
          type="text"
          className="login__textBox"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="E-mail Address"
        />
        <input
          type="password"
          className="login__textBox"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
        />
        <button
          className="login__btn"
          onClick={() => signInWithEmailAndPassword(email, password)}
        >
          Login
  </button> */}
        <button className="login__btn login__google" onClick={signInWithGoogle}><img src={GLogo}/>&nbsp;&nbsp;
          <span>Login with Google</span>
        </button>
        {/*<div>
          <Link to="/reset">Forgot Password</Link>
        </div>
        <div>
          Don't have an account? <Link to="/register">Register</Link> now.
</div>*/}
        <div></div>
        <div>
        <Typography variant="overline" style={{color:"#ffffff"}}>&copy; 2018 TOOCOOL COMPANY LIMITED</Typography>
        </div>
      </div>
      <div></div>
      <div></div>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        <a href="https://play.google.com/store/apps/details?id=com.toocool.gasbot" target="_blank"><img src={PlayStore} width="180px"/></a>
      </div>
      </Stack>
    </div>
  );
}

export default Login;
